import { render } from "./NotificationsOptionsForm.vue?vue&type=template&id=74a5a365&scoped=true"
import script from "./NotificationsOptionsForm.vue?vue&type=script&lang=js"
export * from "./NotificationsOptionsForm.vue?vue&type=script&lang=js"

import "./NotificationsOptionsForm.vue?vue&type=style&index=0&id=74a5a365&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a5a365"]])

export default __exports__